import { Link } from '@elements/link'
import { TablelistAttributionLogo } from '@icons/tablelist-attribution'

export function Footer({ fill = 'currentColor' }: { fill?: string }) {
  return (
    <div className="flex items-start justify-center w-full px-4 pt-3 pb-12 mx-auto mt-6 background-basic">
      <Link
        href="https://www.tablelistpro.com/"
        target="_blank"
        rel="noreferrer"
        className="!text-foreground dark:!text-dark-foreground"
      >
        <TablelistAttributionLogo fill={fill} />
      </Link>
    </div>
  )
}
